import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DesktopProjectModule } from '../project/desktop-project.module';
import { MiscModule } from 'projects/core/src/public-api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProjectMiscModule } from 'projects/app-misc/src/app/modules/project-misc/project-misc.module';
import { OrdersPageComponent } from './view/orders-page/orders-page.component';
import { OrderModalComponent } from './view/order-modal/order-modal.component';
import { AccordionModule } from 'primeng/accordion';
import { MaterialTableComponent } from './view/material-table/material-table.component';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderPdfPreviewDialogComponent } from './view/order-pdf-preview-dialog/order-pdf-preview-dialog.component';
import { ListboxModule } from 'primeng/listbox';
import { AppRoutingModule } from '../../app-routing.module';
import { PaginatorModule } from 'primeng/paginator';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
	declarations: [
		OrdersPageComponent,
		OrderModalComponent,
		MaterialTableComponent,
		OrderPdfPreviewDialogComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TableModule,
		InputTextModule,
		MatDialogModule,
		MatRippleModule,
		MatIconModule,
		MatButtonModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		MatProgressSpinnerModule,
		SelectButtonModule,
		CalendarModule,
		CheckboxModule,
		MiscModule,
		DropdownModule,
		ConfirmDialogModule,
		DesktopProjectModule,
		ProjectMiscModule,
		AccordionModule,
		MultiSelectModule,
		ListboxModule,
		AppRoutingModule,
		PaginatorModule,
    TooltipModule,
		NgxExtendedPdfViewerModule
	],
	entryComponents: [
		OrderModalComponent,
		OrderPdfPreviewDialogComponent
	],
	exports: [
		ListboxModule
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA
	]
})
export class OrdersModule { }
